import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import SideBar from './components/SideBar';
import Footer from './components/Footer';
import { useEffect, useState } from 'react';
import LogoutPopup from './components/LogoutPopup';
import ScrollTop from './components/ScrollTop';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MainLayout = () => {

    const [toggled, setToggled] = useState(false);
    const [hovered, setHovered] = useState(false);

    const handleToggle = () => {
        setToggled(!toggled);
        if (toggled) setHovered(false);
    }

    useEffect(() => {
        toast.info("This is Sporting complex panels", {
            position: "top-right",
            autoClose: 3000,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
        });
    }, []);

    return (
        <div className={`wrapper ${toggled ? "toggled" : ""} ${hovered ? "sidebar-hovered" : ""}`}>
            <ScrollTop />
            <SideBar
                toggled={toggled}
                hovered={hovered}
                setHovered={setHovered}
                handleToggle={handleToggle}
            />
            <Header
                handleToggle={handleToggle}
            />
            <Outlet />
            <Footer />
            <LogoutPopup />
            <ToastContainer />
        </div>
    )
}

export default MainLayout